<template>
  <div>
    <div class="banner withoutImg">
      <div class="container">
        <div class="caption">
          <h1>最新活动</h1>
          <div>
            <p>主题晚宴及Master Class课程</p>
          </div>
        </div>
      </div>
    </div>

    <div class="container">
      <p>&nbsp;</p>
      <div class="breadcrumbWrap">
        <div class="breadcrumb">
            <span property="itemListElement" typeof="ListItem">
              <a
                property="item"
                typeof="WebPage"
                title="Go to Jasper Morris Inside Burgundy."
                href="#/"
                class="home"
              >
                <span property="name">首页</span>
              </a>
              <meta property="position" content="1">
            </span> /
          <span property="itemListElement" typeof="ListItem">
              <a
                property="item"
                typeof="WebPage"
                title="最新活动"
                href="#/theactivity"
                class="home"
              >
                <span property="name">最新活动</span>
              </a>
              <meta property="position" content="2">
            </span>/
          <span property="itemListElement" typeof="ListItem">
                <span property="name">{{content.title}}</span>
              <meta property="position" content="3">
            </span>
            <img src="./../assets/bookmark_before.png" alt="" @click="shuqian(detailContent.id)">
        </div>
      </div>
    </div>

    <div class="container">
      <div style="margin-top:40px;max-width: 667px;margin-left: auto;margin-right: auto;">
        <h3 style="width:100%;text-align: center;">{{content.title}}</h3>
        <div style="width:100%;margin-top:20px;">
          <img :src="content.image" >
        </div>
        <div style="margin-top:5px;">
          <p>发布日期：{{content.createTime}}</p>
        </div>
        <div v-html="content.contentHtml"></div>
        <div class="eventdetails">
          <p>活动时间：{{content.startTime}}</p>
          <p>活动地点：{{content.address}}</p>
          <p>报名价格：{{content.price}}元</p>
          <p>名额限制：{{content.memberCount?content.memberCount:'无限制'}}</p>
          <p>报名截止日期：{{content.joinDeadline}}</p>
        </div>
        <div style="width:100%;text-align:center">
          <img :src="content.qrcodeImage" >
        </div>
        <p style="font-size:20px;color:#000;font-weight:bold;text-align:center">微信扫描此二维码进入小程序完成报名</p>
    </div>
    </div>
  </div>
</template>

<script>
import ajax from '../ajax'
import searchBox from '../template/search'

export default {
  components:{
    searchBox
  },
  data(){
    return {
      detailContent:{},
      userId:"",
      relatedType:"",
      relatedId:"",
      content:{
      }
    }
  },
  created() {
    if(this.$route.query){
      this.getdetail(this.$route.query.id)
    }
  },
  methods: {
    shuqian(id){
      ajax.getVserInfe({
        userId:this.$store.state.userdata.userId,
        relatedType: 3,
        relatedId: id,
          }
        // this.$store.state.userdata.userId
        ).then(res=>{
          console.log(res.data);
        alert("已添加到书签");
      });
      console.log(id)
    },
      getRightdata(){
      ajax.getReportCategories().then(res=>{
        this.rightListdata = res.data
      })
    },
    getdetail(id){
      ajax.getactivityDetail(id).then(res=>{
        this.content = res.data
      })
    },
    hreftwo() {
      this.$router.push({ path: "./insideburgundy" });
    },
    changeActive($event) {
      $event.currentTarget.style = "border-bottom: 4px solid #990033;";
    },
    removeActive($event) {
      $event.currentTarget.style = "";
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/components/Eventdetails.vue